import React, { useCallback, useEffect, useState } from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { useClinicLinks } from "./ClinicAdminPages";
import api, { apiErrorMessage } from "../../lib/api";
import { toast } from "sonner";

export default function ClinicBranchesPage() {
  const links = useClinicLinks();
  const [context, setContext] = useState(null);
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: "", timezone: "Asia/Kolkata", address: "", phone: "", email: "" });
  const load = useCallback(async () => {
    setError("");
    try { setContext((await api.get("/organization/context")).data); }
    catch (e) { setError(apiErrorMessage(e, "Unable to load branches")); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const create = async (event) => {
    event.preventDefault(); setSaving(true);
    try {
      await api.post("/organization/branches", form);
      toast.success("Branch created"); setShowForm(false);
      setForm({ name: "", timezone: "Asia/Kolkata", address: "", phone: "", email: "" });
      await load();
    } catch (e) { toast.error(apiErrorMessage(e, "Unable to create branch")); }
    finally { setSaving(false); }
  };
  return <DashboardLayout links={links} title="Organization & Branches">
    {error ? <div className="mg-card text-red-700" role="alert">{error}<button className="mg-btn-secondary ml-3" onClick={load}>Retry</button></div> : !context ? <div className="mg-card">Loading branches…</div> : <>
      <div className="mg-card mb-5 flex justify-between gap-4 flex-wrap">
        <div><div className="text-xs uppercase text-slate-500">Organization</div><h2 className="text-xl font-bold text-mg-navy">{context.organization?.name}</h2><p className="text-sm text-slate-500">{context.entitlement.active_branch_count} active of {context.entitlement.active_branch_limit ?? "unlimited"} branches · {context.entitlement.plan_name || "Plan unavailable"}</p></div>
        <button className="mg-btn-primary" onClick={() => setShowForm(!showForm)} data-testid="add-branch">Add branch</button>
      </div>
      {showForm && <form className="mg-card mb-5 grid md:grid-cols-2 gap-4" onSubmit={create}>
        <label className="text-sm">Branch name<input required className="mg-input block w-full mt-1" value={form.name} onChange={(e) => setForm({...form,name:e.target.value})}/></label>
        <label className="text-sm">IANA timezone<input required className="mg-input block w-full mt-1" value={form.timezone} onChange={(e) => setForm({...form,timezone:e.target.value})}/></label>
        <label className="text-sm">Address<input className="mg-input block w-full mt-1" value={form.address} onChange={(e) => setForm({...form,address:e.target.value})}/></label>
        <label className="text-sm">Phone<input className="mg-input block w-full mt-1" value={form.phone} onChange={(e) => setForm({...form,phone:e.target.value})}/></label>
        <label className="text-sm">Email<input type="email" className="mg-input block w-full mt-1" value={form.email} onChange={(e) => setForm({...form,email:e.target.value})}/></label>
        <div className="flex items-end gap-2"><button disabled={saving} className="mg-btn-primary">{saving ? "Creating…" : "Create branch"}</button><button type="button" className="mg-btn-secondary" onClick={() => setShowForm(false)}>Cancel</button></div>
      </form>}
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {context.branches.map((branch) => <article className="mg-card" key={branch.clinic_id} data-testid={`branch-${branch.clinic_id}`}>
          <div className="flex justify-between gap-2"><h3 className="font-bold text-mg-navy">{branch.name}</h3><span className="text-xs uppercase">{branch.status}</span></div>
          <p className="text-sm text-slate-500 mt-2">{branch.branch_code} · {branch.timezone}</p><p className="text-sm mt-2">{branch.address || "No address configured"}</p>
          {branch.is_primary_branch && <span className="inline-block mt-3 text-xs bg-blue-50 text-blue-700 rounded-full px-2 py-1">Primary branch</span>}
        </article>)}
      </div>
    </>}
  </DashboardLayout>;
}
